// services/adminservice.js
import {API_SERVER_URL} from "../utils/config_ip_details";
import {apiCall} from "../utils/server_utils"

export const getAllClauses = async () => {
  return apiCall("GET", API_SERVER_URL+"clause/");
};

export const deleteClause = async (delId) => {
  return apiCall("POST", API_SERVER_URL+"clause/"+delId+"/delete/");
};

export const createClause = async (createObject) => {
  return apiCall("POST", API_SERVER_URL+"clause/",createObject);
};

export const updateClause = async (updateId,updateObject) => {
  return apiCall("PUT", API_SERVER_URL+"clause/detail/"+updateId+"/",updateObject);
};


export const getAllTaxonomy = async () => {
  return apiCall("GET", API_SERVER_URL+"taxonomy/");
};

export const deleteTaxonomy = async (delId) => {
  return apiCall("POST", API_SERVER_URL+"taxonomy/"+delId+"/delete/");
};

export const createTaxonomy = async (createObject) => {
  return apiCall("POST", API_SERVER_URL+"taxonomy/",createObject);
};

export const updateTaxonomy = async (updateId,updateObject) => {
  return apiCall("PUT", API_SERVER_URL+"taxonomy/detail/"+updateId+"/",updateObject);
};

export const getClauseDescriptionByName = async (name) => {
  return apiCall("GET", API_SERVER_URL+"clause/description/?clauseName="+name);
};

